<template>
	<div />
</template>

<script>
import { Inertia } from "@inertiajs/inertia";

export default {
	props: {
		title: {
			type: String,
			required: false,
			default: "",
		},
	},
	data() {
		return {
			userType: this.$inertia.page.props.user?.type,
			maxScrollPercentage: 0,
		};
	},
	mounted() {
		window.addEventListener("scroll", this.onScroll);
	},
	created() {
		this.$bus.$on("analytics:new-registration", this.registrationEventListener);
		this.$bus.$on(
			"analytics:complete-profile",
			this.profileCompletionEventListener
		);
		this.$bus.$on("analytics:created-buy", this.createdBuyEventListener);
		this.$bus.$on("analytics:created-sell", this.createdSellEventListener);
		this.$bus.$on("analytics:created-bid", this.createdBidEventListener);

		this.$once(
			"hook:destroyed",
			this.$inertia.on("navigate", this.trackPageView)
		);
	},
	beforeDestroy() {
		this.$bus.$off(
			"analytics:new-registration",
			this.registrationEventListener
		);
		this.$bus.$off(
			"analytics:complete-profile",
			this.profileCompletionEventListener
		);
		this.$bus.$off("analytics:created-buy", this.createdBuyEventListener);
		this.$bus.$off("analytics:created-sell", this.createdSellEventListener);
		this.$bus.$off("analytics:created-bid", this.createdBidEventListener);

		window.removeEventListener("scroll", this.onScroll);
	},
	methods: {
		registrationEventListener() {
			console.log("ANALYTICS_RECEIVED_REGISTRATION");
			if (typeof gtag == "undefined") return;
			gtag("event", "Lead", {
				event_category: "Registrierung",
			});
			gtag("event", "conversion", {
				send_to: "AW-10834729971/prYqCMnH8ZEDEPO3s64o",
			});
			if (typeof fbq !== "undefined") fbq("track", "Lead");
		},
		profileCompletionEventListener() {
			console.log("ANALYTICS_RECEIVED_PROFILE_COMPLETION");
			if (typeof gtag == "undefined") return;
			gtag("event", "CompleteRegistration", {
				event_category: "Registrierung",
				event_label: this.userType,
			});
			if (typeof fbq !== "undefined") fbq("track", "CompleteRegistration", {
				content_name: this.userType,
			});
		},
		createdBuyEventListener() {
			console.log("ANALYTICS_RECEIVED_BUY_SUBMITTED");
			if (typeof gtag == "undefined") return;
			gtag("event", "Verhandlung", {
				event_category: "App-Interaktion",
				event_label: "Nachfrage erstellen",
				user_type: this.userType,
			});
		},
		createdSellEventListener(userType) {
			console.log("ANALYTICS_RECEIVED_SELL_SUBMITTED");
			if (typeof gtag == "undefined") return;
			gtag("event", "Verhandlung", {
				event_category: "App-Interaktion",
				event_label: "Angebot erstellen",
				user_type: this.userType,
			});
		},
		createdBidEventListener(userType) {
			console.log("ANALYTICS_RECEIVED_BID_SUBMITTED");
			if (typeof gtag == "undefined") return;
			gtag("event", "Verhandlung", {
				event_category: "App-Interaktion",
				event_label: "Gebot erstellen",
				user_type: this.userType,
			});
		},
		onScroll(e) {
			if (typeof gtag == "undefined") {
				return;
			}
			let maxScrollHeight =
					document.documentElement.scrollHeight -
					document.documentElement.clientHeight,
				scrollPercentage = (window.scrollY / maxScrollHeight) * 100,
				recordedScrollPercentage = Math.floor(scrollPercentage / 25) * 25; // record 25, 50, 75, 100
			if (recordedScrollPercentage > this.maxScrollPercentage) {
				this.maxScrollPercentage = recordedScrollPercentage;
				gtag("event", `${e.srcElement.location.href}`, {
					event_category: "Scrolling",
					event_label: recordedScrollPercentage,
				});
			}
		},
		trackPageView(event) {
			if (typeof gtag == "undefined") {
				return;
			}
			gtag("event", "page_view", {
				page_location: window.location.href,
				page_path: event.detail.page.url, // inertia event is poorly named because this is not the url but the URI (without scheme and hostname)
				user_type: this.userType,
				page_title: this.title,
			});
			fbq("track", "ViewContent", {
				content_name: event.detail.page.component,
			});
		},
	},
};
</script>
